import { RegistrationType, WebPageDetails } from '@/services/analytics/platforms/adobe-analytics/models';
import { AdobePageLoadEvent } from './adobe-page-load';
import { Store } from 'vuex';
import { AppState } from '@/store';
import { ServicesContainer } from '@/services';
import { CreateAccountPageLoadEvent } from '@/services/analytics/events/create-account-page-load-event';

export class AdobeCreateAccountPageLoadEvent extends AdobePageLoadEvent {
    constructor(event: CreateAccountPageLoadEvent, store: Store<AppState>, services: ServicesContainer) {
        super(store, services);
        
        this.account.registrationStart = { value: 1 };
        this.account.registrationType = RegistrationType.OrderWeb;
        this.account.interactionName = 'registrationStart';

        Object.assign(this.web.webPageDetails, {
            name: 'Create An Account',
            pageType: 'account',
            siteSection: 'account',
            subSection1: 'account',
            siteRegion: 'US',
            subPageName: 'create-account',
            pageViews: { value: 1 },
            subPageViews: { value: 1 },
        } as WebPageDetails);
    }
}
